import React, { useEffect } from 'react';
import type { Achievement } from '../types/index';
import './AchievementNotification.css';

interface AchievementNotificationProps {
  achievement: Achievement;
  onClose: () => void;
}

const AchievementNotification: React.FC<AchievementNotificationProps> = ({ achievement, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="achievement-notification">
      <div className="notification-content">
        <div className="achievement-unlocked">
          <span className="sparkle">✨</span>
          <span>Achievement Unlocked!</span>
          <span className="sparkle">✨</span>
        </div>
        <div className="achievement-info">
          <div className="achievement-icon-large">{achievement.icon}</div>
          <h3>{achievement.name}</h3>
          <p>{achievement.description}</p>
          <div className="points-awarded">+10 Points</div>
        </div>
        <button className="close-notification" onClick={onClose}>
          ✕
        </button>
      </div>
      
      {/* Confetti particles */}
      <div className="confetti-container">
        {[...Array(20)].map((_, i) => (
          <div 
            key={i} 
            className="confetti" 
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 0.5}s`,
              backgroundColor: ['#10b981', '#f59e0b', '#8b5cf6', '#ef4444', '#3b82f6'][Math.floor(Math.random() * 5)]
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default AchievementNotification;